import styled from 'styled-components';

export const FolderItem = styled.div`
	height: 50px;
	padding: 12px 12px 12px 14px;
	box-sizing: content-box;

	position: relative;

	border-radius: 6px;
	background-color: ${({ theme }) => theme['warmgray-50']};

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
	/* gap: 10px; */
	flex-shrink: 0;
`;

export const IconWrapper = styled.div`
	position: absolute;
	top: 18px;
	right: 14px;

	svg {
		width: 16px;
		height: 16px;
	}
`;

export const FolderNameWrapper = styled.div`
	width: calc(100% - 26px);
`;
